const data = [
    {
        hea: "Info",
        tex1: `Vihkiminen klo 14 Hyvinkään vanha kirkko.
                Juhlat jatkuvat Kytäjän kartanon tallilla.`,
        pic: process.env.PUBLIC_URL + '/assets/kuva54.jpg',
        // Kuvan kuvaus
        pde: "Info",
    },
    {
        hea: "Ilmoittautuminen",
        tex1: `Alla olevasta linkistä pääsette ilmoittautumaan vieraaksi hääjuhlaamme.
                Huomioittehan ystävällisesti, että kutsu koskee ainoastaan kutsukirjeessä 
                mainittuja henkilöitä. R.S.V.P. 31.5.2022 mennessä.`,
        pic: process.env.PUBLIC_URL + '/assets/kuva51.jpg',
        // Kuvan kuvaus
        pde: "Ilmoittautuminen",
    },
    {
        hea: "Kuinka pääsen perille",
        tex1: `Hyvinkään vanha kirkko sijaitsee aivan Hyvinkään rautatieaseman tuntumassa.
            Kävelymatka asemalta on 450 metriä. Kirkolta on vihkimisen jälkeen ilmainen 
            bussikuljetus juhlapaikalle, ilmoitathan halukkuutesi bussikuljetukseen ilmoittautumisen 
            yhteydessä.`,
        tex2: `Omalla autolla saapuville parkkipaikkoja on kirkon vieressä tien varressa rajoitetusti.
            Lisätilaa löytyy McDonaldsin vierestä S-marketin pysäköintitalosta,
            johon parhaiten löytää perille asettamalla Google Mapsiin osoitteeksi Hyvinkään McDonaldsin.
            Pysäköinti on maksutonta tunnin ajan.`,
        tex3: `Juhlapaikalla on runsaasti ilmaista pysäköintitilaa. `,
        tex4: `Paluukuljetus tapahtuu omakustanteisesti. Matka tilataksilla juhlapaikalta Hyvinkään 
                rautatieasemalle kustantaa 38 euroa 5-8 hengelle tämänhetkisellä (28.3.) hinnastolla.`,
        pic: process.env.PUBLIC_URL + '/assets/kuva20.jpeg',
        // Kuvan kuvaus
        pde: "Kuvaaja: Amanda Lehtola",
    },
    {
        hea: "Majoitus",
        tex1: `Majoittua Hyvinkäällä voi Hotel Sveitsissä tai Scandicissa.
                Scandic sijaitsee Hyvinkään keskustassa. Sveitsi sijaitsee hieman sivummalla,
                mutta on hotellina viihtyisämpi (ainakin allekirjoittaneiden mielestä).`,
        tex2: `Olemme neuvotelleet 10 % alennuksen majoituksen hinnasta Hotel Sveitsiin koodilla W14.`,
        pic: process.env.PUBLIC_URL + '/assets/kuva52.jpg',
        // Kuvan kuvaus
        pde: "TBA",
    },
    {
        hea: "Valokuvat",
        tex1: `Alla sijaitsevasta painikkeesta voit ladata kuvia morsiusparin kanssa.
        Kuva voi olla vanha tai uusi ja niitä voi ladata yhden tai useamman oman mielen mukaan.
        Kuvassa voi esiintyä kumpi tahansa morsiusparista tai vaikka molemmat ja siinä voi ehdottomasti
        olla muitakin henkilöitä. 
        Varauduttehan siihen, että kuvia on tarkoitus esittää hääjuhlassa.`,
        pic: process.env.PUBLIC_URL + '/assets/kuva22.jpeg',
        // Kuvan kuvaus
        pde: "TBA",
    },
    {
        hea: "Tiedoksi",
        tex1: `Kutsutut henkilöt on nimetty kutsun kuoreen. Mikäli teillä on kutsuihin liittyen kysyttävää
                olettehan matalalla kynnyksellä yhteydessä morsiuspariin. Yhteystietomme löydätte postitse saapuneesta
                kutsusta sekä tämän erillisen otsikon alta tältä sivustolta.`,
        tex2: `Pukukoodista hyviä vinkkejä seuraavan linkin takaa: Häävieras,
                muista nämä säännöt ja ota hääjuhlaetiketti haltuun.`,
        tex3: `Juhlapaikka on esteetön. Juhlapaikalla on mahdollista oleskella sekä ulko- 
                että sisätiloissa. Juhlissamme on alkoholitarjoilu.`,
        tex4: `Toivomme, että kirkossa vihkitilaisuuden aikana puhelimet pidettäisiin taskuissa/laukuissa.
                Meillä on erinomainen valokuvaaja ikuistamassa päiväämme ja hänen ottamansa kuvat tulee kaikkien
                vieraiden käyttöön tälle nettisivuille juhlien jälkeen.`,
        tex5: `Mikäli haluatte jakaa juhlistamme otettuja kuvia sosiaalisessa mediassa, voitte käyttää hashtagia 
                #XXXXX, jotta muutkin vieraamme löytävät upeat kuvateoksenne!`,
        pic: process.env.PUBLIC_URL + '/assets/kuva53.jpg',
        // Kuvan kuvaus
        pde: "TBA",
    },
    {
        hea: "Kartta",
        tex1: "TBA",
        pic: "TBA",
        pde: "TBA",
    },
    {
        res1: "3 kananmunaa | 6 dl kevytmaitoa | 3 dl vehnäjauhoja | 1 rkl sokeria | 1 tl suolaa",
        res2: "ylempi 60 annoksen, tutumpi 40 annoksen",
    },
];

export default data;